var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersMedicalSm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.161,
    height: 12.929,
    viewBox: "0 0 16.161 12.929",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-medical",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4498",
    "data-name": "Path 4498",
    d: "M450.02,320a.405.405,0,0,0-.4.4v1.212H448.4a.405.405,0,0,0-.4.4v.808a.405.405,0,0,0,.4.4h1.212v1.212a.405.405,0,0,0,.4.4h.808a.405.405,0,0,0,.4-.4v-1.212h1.212a.405.405,0,0,0,.4-.4v-.808a.405.405,0,0,0-.4-.4h-1.212V320.4a.405.405,0,0,0-.4-.4Z",
    transform: "translate(-436.687 -311.919)",
    fill: "#888",
    opacity: 0.802
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4499",
    "data-name": "Path 4499",
    d: "M1.616,2.02a2.02,2.02,0,1,1,2.02,2.02,2.02,2.02,0,0,1-2.02-2.02Zm9.293,0a2.02,2.02,0,1,1,2.02,2.02,2.02,2.02,0,0,1-2.02-2.02ZM2.694,4.848H3.773A2.709,2.709,0,0,1,4.9,5.093a3.178,3.178,0,0,0-.048.563A3.233,3.233,0,0,0,5.944,8.081H.538A.54.54,0,0,1,0,7.543,2.7,2.7,0,0,1,2.694,4.848Zm7.525,3.232a3.224,3.224,0,0,0,1.093-2.424,3.458,3.458,0,0,0-.048-.563,2.67,2.67,0,0,1,1.126-.245h1.078a2.7,2.7,0,0,1,2.692,2.694.538.538,0,0,1-.538.538h-.338a1.215,1.215,0,0,0-1.144-.808h-.808a1.215,1.215,0,0,0-1.144.808h-1.97Zm.712,1.1a1.2,1.2,0,0,0-.427.922v.808a1.212,1.212,0,0,0,1.212,1.212h.4v.4a1.256,1.256,0,0,0,.068.4H3.906a.674.674,0,0,1-.674-.674A3.367,3.367,0,0,1,6.6,8.889H9.563A3.349,3.349,0,0,1,10.932,9.179ZM8.081,3.232A2.424,2.424,0,1,1,5.656,5.656,2.424,2.424,0,0,1,8.081,3.232Z",
    fill: "#047BC1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersMedicalSm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users-medical-sm.b20269f277185906cfd91d7dde81f1b5.svg";